<div class="main-wrapper">
  <div class="container">
    <div class="row">
      <div class="section_1_headerArea col-lg-6 col-md-6 col-12 col-sm-6 padding-0">
        <div class="heading d-lg-block d-md-none d-sm-none d-none">{{section?.header}}</div>
        <div id="medical-banner-slide" class="section_1_pictures d-lg-block d-md-none d-sm-none d-none">
          <a *ngFor="let item of section?.data_images" class="" href="javascript:;" [title]="item?.text">
            <img loading="lazy" class="section_1_image" [attr.data-src]="item?.url">
          </a>
        </div>
        <div class="section_1_pictures d-block d-sm-none mobile">
          <div class="picturewrapper">
            <img loading="lazy" class="section_1_image" data-src="/assets/images/medical-fr/leadgen_zerofee.png">
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-12 col-sm-6">
        <div class="lead-form">
          <div class="header text-center">
            <img loading="lazy" data-src="/assets/images/how-it-works/ketto-logo.svg" alt="" />
            <div class="main-title">
              We know you are in urgent need of funds.
              <div inViewport (inViewportAction)="whatsappToggle($event)" class="sac-wrapper">
                <a type="submit" (click)="systemEvent($event)" mat-button class="chat-on-whatsapp" target="_blank" [href]="'https://api.whatsapp.com/send?phone=91' + vars.contactUsMobNumber">
                  <mat-icon class="icon-whatsapp icon-btn"></mat-icon>
                  Chat with us on whatsapp
                </a>
              </div>
              <h3 class="or">OR</h3>
              <span class="subtitle">
                Fill out the form below and our personal fundraiser expert is waiting to get you started!
              </span>
            </div>
          </div>
          <app-common-talktous-modal class="action-btns" [header]="false" label="Get a call" [closebtn]="false"
                                    [showSacBtn]="true" [campaignCount]="vars.campaignCount"
                                    leadQueryType="want_to_raise_funds" frCause="medical" [askQuery]="false"
                                    [hideFields]="{typeOfQuery: true, cause: true}" [successPopup]="true">
          </app-common-talktous-modal>
        </div>
      </div>
    </div>
  </div>
</div>

<div #whatsAppSticky class="d-lg-none d-md-none" (click)="pushWhatsappEvent($event)">
  <a href="javascript:void(0)" class="whatsapp-share-unstick" mat-raised-button>
    <i class="icon-whatsapp"></i>
    Chat with us on Whatsapp</a>
</div>
